import { render } from "./PhotoCamera.vue?vue&type=template&id=e7dafd2e"
import script from "./PhotoCamera.vue?vue&type=script&lang=js"
export * from "./PhotoCamera.vue?vue&type=script&lang=js"

import "./PhotoCamera.vue?vue&type=style&index=0&id=e7dafd2e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__